var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progressBarBox"},[_c('div',{staticClass:"progressBar"},[_c('div',{staticClass:"currentProgress",class:{ type2: _vm.isTljGone }},[_vm._v("\n      "+_vm._s(_vm.isTljGone ? "即将抢光": "正在热抢")+"\n    ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }